// Hand-written view-model types for the SPA that have no Go DTO counterpart.
//
// The API contract types (Transaction, Debt, Budget, Account, …) and the
// value-enums (DebtType, Frequency, AllocationKind, …) are GENERATED from Go
// into ./generated.ts and re-exported here, so `$lib/db` stays the single import
// site. Edit those in Go (internal/apitypes / internal/domain) and run
// `go generate ./...`; do not hand-edit generated.ts.
export * from './generated';
import type { Allocation, PaymentRole, UnpaidCharge } from './generated';

// CategoryType is a SPA-side classification of a category. It has no backing Go
// enum — the Go Category.type is a free-form string — so it lives here and drives
// the type-aware budget/dashboard UI.
export type CategoryType = 'Income' | 'Mandatory Costs' | 'Non-Essential Spending' | 'Saving' | 'Spending' | '';

export const CATEGORY_TYPES: CategoryType[] = [
	'Income',
	'Mandatory Costs',
	'Non-Essential Spending',
	'Saving',
	'Spending',
];

// PaymentSuggestion is the allocation breakdown the API suggests for a debt
// payment. The backend computes it on the fly rather than persisting a named
// struct, so it stays hand-written here (its parts are generated types).
export interface PaymentSuggestion {
	magnitude: number;
	allocations: Allocation[];
	unpaidPool: UnpaidCharge[];
	legacyRemaining: number;
	role: PaymentRole;
	minimumPortion: number;
	extraPortion: number;
}

// CategorySummary is an aggregate of a category's transactions, computed
// client-side for the budget/dashboard views.
export interface CategorySummary {
	category: string;
	total: number;
	count: number;
}
